import {GetRepoSummariesResponse} from "@/pb/api/devplan/services/web/company";
import {RepositorySummary} from "@/pb/api/devplan/types/integrations";
import {CodeResearchAreaMeta, CodeResearchOrganizationMeta} from "@devplan/contextify-api";
import {ResearchArea} from "@/app/data/code/research";

// type alias for ambiguous string type: RepositorySummary.id
type RepoSummaryId = string
// type alias for ambiguous string type: areaMetas[].meta.repoFullName or RepositorySummary.repoName
type RepoFullName = string

export function loadRepositorySummaries(resp: GetRepoSummariesResponse): {
  summaries: Record<RepoSummaryId, RepositorySummary>,
  repoResearchMetas: Record<RepoFullName, CodeResearchAreaMeta[]>,
  repoResearchAreas: Record<RepoFullName, ResearchArea[]>,
} {
  const summaries = resp.repoSummaries.reduce((a, s) => ({
    ...a,
    [s.id]: s
  }), {} as Record<RepoSummaryId, RepositorySummary>);
  const orgMetas = resp.codeResearchMetas.map(r => CodeResearchOrganizationMeta.fromJSON(JSON.parse(r.data)));
  const repoResearchMetas: Record<RepoFullName, CodeResearchAreaMeta[]> = {};
  const repoResearchAreas: Record<RepoFullName, ResearchArea[]> = {};

  resp.repoSummaries.values().forEach(rs => {
    const fullName = rs.repoName
    repoResearchAreas[fullName] = repoResearchAreas[fullName] || [];
    repoResearchAreas[fullName].push({ key: "summary", title: "Summary" });
  });

  orgMetas.forEach(m => {
    m.areaMetas.forEach(a => {
      const fullName = a.meta?.repoFullName;
      if (!fullName) {
        return;
      }
      const metas: CodeResearchAreaMeta[] = repoResearchMetas[fullName] ?? [];
      metas.push(a);

      repoResearchMetas[fullName] = metas;
      // add the available research areas for this repo
      repoResearchAreas[fullName] = repoResearchAreas[fullName] || [];
      const dirKey = a.meta?.dirKey;
      const researchAreaKey = dirKey?.name?.trim();
      if (!researchAreaKey) {
        return;
      }
      if (dirKey?.kind !== "repo_research") {
        return;
      }
      // don't add duplicate (only really applies to "summary" key)
      if (repoResearchAreas[fullName].findIndex(a => a.key == researchAreaKey) >= 0) {
        return;
      }
      repoResearchAreas[fullName].push({
        key: researchAreaKey!,
        // To discuss in PR: I prefer to fall back to displaying the key (uppercase), or omitting this research area
        // The current navbar falls back to empty string... which would be bizarre as you'd have nothing to click on.
        title: a.meta?.areaTitle || researchAreaKey!.toUpperCase(),
      });
    });
  });
  return { summaries, repoResearchMetas, repoResearchAreas };
}
